// TODO: [Sportybet]
export enum TransactionType {
  Deposit = 1,
  Withdrawal = 2,
  Bet = 3
}

export enum TransactionStatus {
  Successful = 1,
  Failed = 2,
  Pending = 3
}

export const RuleEngineTime = 3; // sec

// TODO: [Sportybet]
export enum Country {
  KE = 'ke',
  NG = 'ng',
  GH = 'gh',
  ZM = 'zm',
  TZ = 'tz',
  UG = 'ug',
  // New
  INT = 'int',
  CM = 'cm',
  ZA = 'za',
  BR = 'br',
  MX = 'mx',
  MZ = 'mz'
}
// TODO: [Sportybet]
export const CurrencyMap: Record<Country|string, string> = {
  [Country.KE]: 'KES',
  [Country.NG]: 'NGN',
  [Country.GH]: 'GHS',
  [Country.ZM]: 'ZMW',
  [Country.TZ]: 'TZS',
  [Country.UG]: 'UGX',
  [Country.INT]: 'TEST',
  [Country.CM]: 'XAF',
  [Country.ZA]: 'ZAR',
  [Country.BR]: 'BRL',
  [Country.MX]: 'MXN',
  [Country.MZ]: 'MZN',
};
// TODO: [Sportybet]
export enum OrderType {
  Single = 1,
  Multiple = 2,
  System = 3
}

export enum PaySource {
  UNKNOWN = 0, // means is not withdraw or deposit, may be a place bet action
  CARD = 1,
  BANK = 2,
  MOBILE_MONEY = 3,
  OTHERS = 4,
}

// Only Used in Native
export const MINIMIZE_TIME = 1140; // 19 min * 60 = 1140 sec

// Before, they has another provider zendesk
export enum CustomerServiceProvider {
  PLEASED = 'pleased',
}

export const LETTERS_DIGITS_SPACES_REGEXP = /[^a-zA-Z0-9\s]/g;
export const MAX_ARTICLE_AUTOCOMPLETE_CHAR_NUM = 50;
export const MIN_ARTICLE_AUTOCOMPLETE_TEXT_LENGTH = 3;

export const MIN_DESCRIPTION_CHAR_NUM = 3;
export const MAX_DESCRIPTION_CHAR_NUM = 1800;

export const MAX_GUEST_FIELDS_CHAR = {
  name: 100,
  email: 100,
  phone: 20,
  description: MAX_DESCRIPTION_CHAR_NUM,
} as const;

export const SYSTEM_MESSAGE_PREFIX = 'Query:';
export const ARTICLE_SEARCH_SYSTEM_MESSAGE_PREFIX = 'Article Search:';
export const USER_MESSAGE_FOR_AI_PREFIX = 'Query Request:';
export const AI_MESSAGE_FOR_USER_PREFIX = 'Query Response:';
export const INITIAL_LOADING_MESSAGE_ID = 'initial-loading-message';
export const METADATA_MESSAGE_PREFIX = '[METADATA] ';